/**
 * Originals CBD - Cart Drawer & Main Cart Upsells
 *
 * Appends a "Quick add-ons" strip to:
 *   1. The bottom of the scrollable cart drawer items area
 *   2. The #MainCart-Upsells placeholder on the main /cart page
 *
 * Add-on products come from the inline JSON rendered by cart-drawer.liquid
 * (metaobjects.cart_add_ons → #CartDrawer-AddOns script tag).
 *
 * After an upsell add, passes `sections` in the /cart/add.js body so Shopify
 * returns re-rendered section HTML in one round trip.
 */

(function () {
  'use strict';

  var UPSELL_COUNT = 3;
  var FREE_DELIVERY_THRESHOLD = 7000; // pence - must match cart-drawer.liquid
  var CONTAINER_ID = 'CartDrawer-Upsells';
  var MAIN_CONTAINER_ID = 'MainCart-Upsells-Container';
  var CART_SECTION_ID = 'cart-drawer';
  var MAIN_CART_SECTION_ID = 'main-cart-items';

  // ── Money helper ────────────────────────────────────────────────────────────

  function formatMoney(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  // ── Data helpers ────────────────────────────────────────────────────────────

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) {
      return r.json();
    });
  }

  // Reads add-on products from the inline JSON rendered by cart-drawer.liquid
  // (#CartDrawer-AddOns) or main-cart-items.liquid (#MainCart-AddOns). Returns [] if absent.
  function getAddOns() {
    var el = document.getElementById('CartDrawer-AddOns') || document.getElementById('MainCart-AddOns');
    if (!el) return [];
    try { return JSON.parse(el.textContent) || []; }
    catch (e) { return []; }
  }

  // ── SVG icons ───────────────────────────────────────────────────────────────

  var plusSvg =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="2.5" stroke-linecap="round" aria-hidden="true">' +
    '<line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';

  var tickSvg =
    '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
    'stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<polyline points="20 6 9 17 4 12"/></svg>';

  // ── Card HTML builder ───────────────────────────────────────────────────────

  function buildCardsHtml(suggestions) {
    return suggestions.map(function (product) {
      var variant =
        product.variants.find(function (v) { return v.available; }) ||
        product.variants[0];

      var imgSrc = product.featured_image || '';

      var safeTitle = product.title
        .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
        .replace(/</g, '&lt;').replace(/>/g, '&gt;');

      var imgTag = imgSrc
        ? '<img class="drawer__upsell-img" src="' + imgSrc + '" alt="' + safeTitle + '" loading="lazy" width="60" height="60">'
        : '<div class="drawer__upsell-img drawer__upsell-img--placeholder"></div>';

      return (
        '<div class="drawer__upsell-card" data-product-id="' + product.id + '">' +
        imgTag +
        '<div class="drawer__upsell-info">' +
        '<p class="drawer__upsell-title">' + safeTitle + '</p>' +
        '<p class="drawer__upsell-price">' + formatMoney(variant.price) + '</p>' +
        '</div>' +
        '<button class="drawer__upsell-btn"' +
        (variant.available ? '' : ' disabled') +
        ' data-variant-id="' + variant.id + '"' +
        ' aria-label="Add ' + safeTitle + ' to cart">' +
        plusSvg +
        '</button>' +
        '</div>'
      );
    }).join('');
  }

  function buildContainer(id, cardsHtml) {
    var container = document.createElement('div');
    container.id = id;
    container.className = 'drawer__upsells';
    container.innerHTML =
      '<p class="drawer__upsells-heading">Quick add-ons</p>' +
      '<div class="drawer__upsells-track">' + cardsHtml + '</div>';
    return container;
  }

  function attachAddHandlers(container) {
    container.querySelectorAll('.drawer__upsell-btn').forEach(function (btn) {
      btn.addEventListener('click', handleAdd);
    });
  }

  // ── Render upsell strips ────────────────────────────────────────────────────

  function loadUpsells() {
    var cartItemsEl = document.getElementById('CartDrawer-CartItems');
    var mainUpsellsEl = document.getElementById('MainCart-Upsells');
    if (!cartItemsEl && !mainUpsellsEl) return;

    // Fetch first, then swap atomically - never leaves an empty state
    fetchCart().then(function (cart) {
      var cartProductIds = {};
      if (cart.items) {
        cart.items.forEach(function (item) { cartProductIds[item.product_id] = true; });
      }

      var suggestions = (cart.items && cart.items.length > 0)
        ? getAddOns()
            .filter(function (p) { return !cartProductIds[p.id] && p.available; })
            .slice(0, UPSELL_COUNT)
        : [];

      var cardsHtml = suggestions.length ? buildCardsHtml(suggestions) : null;

      // ── Cart drawer ───────────────────────────────────────────────────────
      var existingDrawer = document.getElementById(CONTAINER_ID);
      if (existingDrawer) existingDrawer.remove();
      cartItemsEl = document.getElementById('CartDrawer-CartItems');
      if (cartItemsEl && cardsHtml) {
        var dc = buildContainer(CONTAINER_ID, cardsHtml);
        cartItemsEl.appendChild(dc);
        attachAddHandlers(dc);
      }

      // ── Main cart page - atomic swap, no empty state ─────────────────────
      mainUpsellsEl = document.getElementById('MainCart-Upsells');
      if (mainUpsellsEl) {
        var existingMain = document.getElementById(MAIN_CONTAINER_ID);
        if (cardsHtml) {
          var mc = buildContainer(MAIN_CONTAINER_ID, cardsHtml);
          if (existingMain) {
            existingMain.replaceWith(mc); // swap in one operation
          } else {
            mainUpsellsEl.appendChild(mc);
          }
          attachAddHandlers(mc);
        } else {
          if (existingMain) existingMain.remove();
        }
      }
    }).catch(function () {});
  }

  // ── Add-to-cart ─────────────────────────────────────────────────────────────

  function handleAdd(e) {
    var btn = e.currentTarget;
    if (btn.disabled) return;

    var variantId = parseInt(btn.dataset.variantId, 10);
    var card = btn.closest('.drawer__upsell-card');

    // Determine context: main cart page or drawer
    var isMain = !!btn.closest('#MainCart-Upsells');
    var sectionId = isMain ? MAIN_CART_SECTION_ID : CART_SECTION_ID;

    btn.disabled = true;
    btn.innerHTML = '<span class="drawer__upsell-spinner"></span>';

    var body = { id: variantId, quantity: 1, sections: sectionId };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'failed'); });
        return r.json();
      })
      .then(function (data) {
        // 1. Show success on button while it's still in the DOM
        btn.innerHTML = tickSvg;
        btn.classList.add('drawer__upsell-btn--added');

        // 2. Fade the card out
        if (card) {
          card.style.transition = 'opacity 0.35s ease, transform 0.35s ease';
          card.style.opacity = '0';
          card.style.transform = 'scale(0.95)';
        }

        // 3. After the fade, update the cart items list + totals + strip
        setTimeout(function () {
          if (data.sections && data.sections[sectionId]) {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(data.sections[sectionId], 'text/html');

            if (isMain) {
              // Re-render main cart items (.js-contents inside #main-cart-items)
              var newContents = newDoc.querySelector('#main-cart-items .js-contents');
              var currentContents = document.querySelector('#main-cart-items .js-contents');
              if (newContents && currentContents) {
                currentContents.innerHTML = newContents.innerHTML;
              }
            } else {
              // Re-render cart drawer items (#CartDrawer-CartItems)
              var newItems = newDoc.getElementById('CartDrawer-CartItems');
              var currentItems = document.getElementById('CartDrawer-CartItems');
              if (newItems && currentItems) {
                currentItems.innerHTML = newItems.innerHTML;
              }
            }
          }

          // Update totals / badge / delivery bar
          fetchCart().then(function (cart) {
            syncCartDisplay(cart);
          });

          // Rebuild upsell strip (removes the added product, shows fresh suggestions)
          loadUpsells();
        }, 400);
      })
      .catch(function () {
        btn.disabled = false;
        btn.innerHTML = plusSvg;
      });
  }

  // ── Sync totals / badge / delivery bar ─────────────────────────────────────

  function syncCartDisplay(cart) {
    var FREE_THRESHOLD = FREE_DELIVERY_THRESHOLD;
    var deliveryHtml = cart.total_price >= FREE_THRESHOLD
      ? 'Free'
      : '<a href="/policies/shipping-policy" class="cart__delivery-info-link" aria-label="View delivery and returns policy">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>' +
        '</a>';

    // Cart drawer: first totals__total-value = subtotal, second = delivery
    var drawerTotals = document.querySelectorAll('#CartDrawer .totals__total-value');
    if (drawerTotals[0]) drawerTotals[0].textContent = formatMoney(cart.total_price);
    if (drawerTotals[1]) drawerTotals[1].innerHTML = deliveryHtml;

    // Main cart footer: same pattern
    var mainTotals = document.querySelectorAll('#main-cart-footer .totals__total-value');
    if (mainTotals[0]) mainTotals[0].textContent = formatMoney(cart.total_price);
    if (mainTotals[1]) mainTotals[1].innerHTML = deliveryHtml;

    // Item count badge (drawer only)
    var countEl = document.querySelector('#CartDrawer .drawer__item-count');
    if (countEl) countEl.textContent = cart.item_count;

    updateDeliveryBar(cart.total_price);
  }

  function updateDeliveryBar(totalPence) {
    // Update all delivery bars (drawer + main cart page)
    document.querySelectorAll('.drawer__delivery-bar').forEach(function (bar) {
      var fill = bar.querySelector('.drawer__delivery-fill');
      var msg  = bar.querySelector('.drawer__delivery-msg');
      if (!fill || !msg) return;

      fill.style.width = Math.min((totalPence / FREE_DELIVERY_THRESHOLD) * 100, 100) + '%';

      var truckSvg =
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
        'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<rect x="1" y="3" width="15" height="13"/><path d="M16 8h4l3 5v3h-7V8z"/>' +
        '<circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>';

      if (totalPence >= FREE_DELIVERY_THRESHOLD) {
        bar.style.display = 'none';
      } else {
        bar.style.display = '';
        msg.innerHTML =
          truckSvg + ' <strong>' + formatMoney(FREE_DELIVERY_THRESHOLD - totalPence) + '</strong> away from free delivery';
        msg.classList.remove('drawer__delivery-msg--achieved');
      }
    });
  }

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    loadUpsells();

    // Re-render after every Dawn cart update (fires after DOM is already updated)
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        setTimeout(loadUpsells, 80);
      });
    }

    // Re-render each time the cart drawer is opened (body gains overflow-hidden)
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].attributeName === 'class' &&
          document.body.classList.contains('overflow-hidden')
        ) {
          loadUpsells();
          break;
        }
      }
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
